import React, { useEffect, useState } from 'react'
import TableComponent from 'components/Table'
import { CreditRowItem } from '../../CreditRowItem'

const ActiveCreditList = (props: any) => {
  console.log('activelist')
  console.log(props.expandedRowKeys)
  return (
    <TableComponent
      onRow={props.onRow}
      rowClassName={(record: any, index: number) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
      columns={props.columnsData}
      scroll={{ x: 1000 }}
      className="credit-table  transfer-table salary-table credit_table creditFixedColumnTable"
      data={props.data}
      pagination={false}
      rowSelection={false}
      pageSize={props.pageSize}
      onChange={props.handleChange}
      ellipsis
      bordered={false}
      expandedRowKeys={props.expandedRowKeys}
      onExpand={props.onExpand}
      expandable={{
        expandedRowRender: (record: any) => {
          console.log(record)
          return (
            <CreditRowItem
              leftItems={record}
              styleCreditRowColumLeft={{ marginLeft: 80 }}
              styleCreditRowColum={{ marginLeft: -58 }}
              handleRowClose={props.handleRowClose}
              tableData={record} />
          )
        },
        // rowExpandable: (record: any) => {
        //   if (props.firstRow) {
        //     return false
        //   } else {
        //     return true
        //   }
        // },
        expandRowByClick: true,
        expandIconColumnIndex: -1,
        showExpandColumn: false,
        // onExpand: (expanded: any, record: any) => {
        //     console.log(expanded, 'expanded')
        //     console.log(record, 'record')
        // },
        // expandIcon: () => null
      }} />
  )
}
export default ActiveCreditList
